/**
 * The logout cleanup registry.
 *
 * Each module keeps its own durable store — groceries in the `familyhub` Dexie
 * database, agenda in `familyhub-agenda`. Logout (and an expired session) must
 * wipe them all, because a shared phone must not keep the household's data. But
 * the platform session code must not import a module, so modules register a wipe
 * here and the session drains it.
 *
 * Best-effort per module: one failing wipe must not leave the others un-wiped.
 */
type Cleanup = () => Promise<void>;

const cleanups = new Set<Cleanup>();

export function registerCleanup(fn: Cleanup): void {
  cleanups.add(fn);
}

export async function runModuleCleanups(): Promise<void> {
  await Promise.all(
    [...cleanups].map((fn) => fn().catch((err) => console.warn('module cleanup failed', err))),
  );
}
